import React, { useState } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import {Modal, Space } from 'antd';
import PublishDesc from './PublishDesc';
function PublishCheck(props) {
    const [open,setOpen] = useState(false)
    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.bggfb_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <PublishDesc 
                    bggfb_id={props.bggfb_id}
                />            
            </Modal>
        </>
    )
}

export default PublishCheck